import type { ReactNode } from 'react';

import { Navigate } from 'react-router';

import { useUser } from '@ll-platform/frontend/core/auth/hooks/useUser';
import { isUserInternal } from '@ll-platform/frontend/core/auth/utils/isInternal';
import { Pages } from '@ll-platform/frontend/core/router/pages';
import { makeNextParamForCurrent } from '@ll-platform/frontend/utils/helpers/navigation';

type AuthRedirectControllerProps = {
  unauthorizedRedirectPage?: string;
  emailHint?: string;
  loadingComponent: ReactNode;
};

export function AuthRedirectController({
  unauthorizedRedirectPage = Pages.Login,
  emailHint,
  loadingComponent,
}: AuthRedirectControllerProps) {
  const { isLoading, isAuthorized, activeUser } = useUser();

  if (isLoading) {
    return loadingComponent;
  }

  if (!isAuthorized) {
    return (
      <Navigate
        to={`${unauthorizedRedirectPage}?${makeNextParamForCurrent()}${
          emailHint
            ? `&${new URLSearchParams({ email: emailHint.toLowerCase() })}`
            : ''
        }`}
      />
    );
  }

  if (isUserInternal(activeUser)) {
    return <Navigate to={Pages.InternalDashboardRedirect} replace />;
  }

  return <Navigate to={Pages.DashboardRedirect} replace />;
}
